import type { CreditsState } from "@repo/types"
import { create } from "zustand"

export const useCredits = create<CreditsState>((set) => ({
  set: (x) => set((p) => ({ ...p, lastUpdated: Date.now(), balance: x })),
  // setCreditsUpdated: () => set((p) => ({ ...p, lastUpdated: Date.now() })),
  lastUpdated: Date.now(),
  balance: null
}))
